// src/app/services/language.service.ts
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(private translate: TranslateService) {}

  initLanguage() {
    const lang = localStorage.getItem('lang') || 'en';
    this.translate.use(lang);
  }

  setLanguage(lang: string) {
    localStorage.setItem('lang', lang);
    this.translate.use(lang);
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang || 'en';
  }
}
